import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextIndentRight"><Path d="M21.5 14.5V9.5L18 12L21.5 14.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 6.5H2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 12H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 17.5H2.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTextIndentRight;
